import LayoutPage from "./LayoutPage";
import classes from "../../components/Services.module.css";
import AttorneyForm from "../../components/Forms/AttorneyForm";
function AttorneyBridgeFinance() {
  return (
    <>
      <LayoutPage
        heading="ATTORNEY FINANCE"
        Form={
          <>
            <h2 className={`text-center ${classes.h1}`}>Apply Now</h2>
            <div
              style={{
                backgroundColor: "#113358",
                overflow: "hidden",
                borderRadius: "2%",
                padding: "20px",
              }}
            >
              <AttorneyForm
                heading={
                  "RAF Attorney- Complete this form to apply for an Attorney Advance"
                }
              />
            </div>
          </>
        }
      >
        <div className=" row">
          <div className="col-md-7 col-lg-7 mb-3 mb-md-0 bg-light">
            {" "}
            <h1 className={classes.h1}>Attorney Finance</h1>
            <p className={`${classes.p}`}>
              RAF Attorney Finance is a specialized financial service designed
              to advance legal fees for attorneys handling Road Accident Fund
              (RAF) claims. Once a RAF claim has been settled, attorneys often
              face delays in receiving their fees. RAF Attorney Finance provides
              an advance on these fees, ensuring that attorneys can maintain
              their cash flow and continue to operate effectively while waiting
              for the RAF payout.
            </p>
            {/* <h4 className={classes.h4}>What you need to apply</h4>
            <ol className={classes.ol}>
              <li>Settled RAF Claim</li>
              <li>Personal Identification</li>
              <li>ID Document</li>
              <li>Legal Practice Information</li>
            </ol> */}
            <h4 className={classes.h4}>
              How Long Until You Receive Your Funds?
            </h4>
            <p className={classes.p}>
              Funds are disbursed within 24 hours after the agreement is signed.
            </p>
          </div>
          <div className="col-md-4 col-lg-5">
            <div className={classes["background-image-div-3"]}></div>
          </div>
        </div>
      </LayoutPage>
    </>
  );
}

export default AttorneyBridgeFinance;
